import { Route, Routes } from 'react-router-dom';
import { routes } from './app/routes.js';
import { ProtectedRoute } from './shared/ProtectedRoute.jsx';
import { LandingLayout } from './pages/LandingLayout/index.jsx';
import { Toaster } from 'sonner';
import { NotFound } from './error/NotFound.jsx';
import { Layout } from './app/layout/Layout.jsx';
import { NavigationProvider } from './shared/utils/NavigationProvider.jsx';
import { EmbedAuthProvider } from './shared/contexts/EmbedAuthContext.jsx';
import { CommandPalette } from './shared/components/CommandPalette.jsx';
import { useEmitRouteChange } from './shared/hooks/useEmitRouteChange.js';

import GlobalContext from './shared/contexts/GlobalContext.jsx';

function App() {
  useEmitRouteChange();
  return (
    <>
      <Toaster
        richColors
        position="top-right"
        closeButton
      />
      <GlobalContext>
        <NavigationProvider>
          <EmbedAuthProvider>
            {/* Mounted here, not in Layout: the noLayer embed pages never render
                Layout and must still get the palette. */}
            <CommandPalette />
            <Routes>
              <Route element={<Layout />}>
                {routes
                  .filter((r) => !r.noLayer)
                  .map((route) => {
                    const { path, component: Component, protectedBy, redirectPath } = route;
                    return (
                      <Route
                        key={path}
                        path={path}
                        element={
                          <ProtectedRoute protectedBy={protectedBy} redirectPath={redirectPath}>
                            <Component />
                          </ProtectedRoute>
                        }
                      />
                    );
                  })}
              </Route>

              <Route element={<LandingLayout />}>
                {routes
                  .filter((r) => r.corporative)
                  .map((route) => {
                    const { path, component: Component } = route;
                    return (
                      <Route key={path} path={path} element={<Component />} />
                    );
                  })}
              </Route>

              {routes
                .filter((r) => r.noLayer)
                .map((route) => {
                  const { path, component: Component, protectedBy, redirectPath } = route;
                  return (
                    <Route
                      key={path}
                      path={path}
                      element={
                        <ProtectedRoute protectedBy={protectedBy} redirectPath={redirectPath}>
                          <Component />
                        </ProtectedRoute>
                      }
                    />
                  );
                })}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </EmbedAuthProvider>
        </NavigationProvider>
      </GlobalContext>
    </>
  );
}

export default App;
